import { Button, Flex, message, Modal } from "antd";
import React, { useState } from "react";

import { controller } from "./controller";

export default function ConfirmRemoveTagModal({ showConfirmRemoveModal, setShowConfirmRemoveModal, setTagToRemove, getAllTags, tag }) {
  const [isRemovingTag, setIsRemovingTag] = useState(false);

  async function handleRemoveTag() {
    try {
      setIsRemovingTag(true);

      const response = await controller.removeTag(tag.id);

      if (response.status === 204) {
        setShowConfirmRemoveModal(false);
        setTagToRemove({});
        getAllTags();
        message.success("Tag removed successfully");
      }
    } catch (err) {
      message.error("Something went wrong while removing tag");
      console.error(err);
    } finally {
      setIsRemovingTag(false);
    }
  }

  return (
    <Modal title="Confirm Remove Tag" open={showConfirmRemoveModal} onCancel={() => setShowConfirmRemoveModal(false)} footer={null}>
      <Flex vertical>
        <p>
          Are you sure you want to remove <span style={{ color: "#6b42b5" }}>{tag.name}</span>?
        </p>

        <Flex gap={10} align="center" style={{ marginLeft: "auto" }}>
          <Button style={{ border: "1px solid #6b43b5", color: "#6b43b5" }} onClick={() => setShowConfirmRemoveModal(false)} disabled={isRemovingTag}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleRemoveTag} loading={isRemovingTag}>
            Remove
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
